export default __webpack_public_path__ + "static/media/1-comunicacao.e8720d0f.svg";